import axios from 'axios';
export default class Tabs {
    constructor() {
        this.sections = document.querySelectorAll('.uni-tabs');

        this.ready();
    }

    ready() {
        this.sections.forEach((tabSection) => {
            const menusTabs = tabSection.querySelectorAll('.menuTabs ul li');
            const contentTabs = tabSection.querySelectorAll('.contentTabs .tab');
            menusTabs.forEach((menu) => {
                menu.addEventListener('click', () => {
                    const tab = menu.dataset.tab;
                    menusTabs.forEach((menuOld) => {
                        menuOld.classList.remove('active');
                    });
                    menu.classList.add('active');
                    contentTabs.forEach((tabItem) => {
                        tabItem.classList.remove('active');
                    });
                    document.querySelector('#' + tab).classList.add('active');
                });
            });

            const inputProduct = tabSection.querySelector('#products');
            const inputUnit = tabSection.querySelector('#unit');
            const template = tabSection.querySelector('#template').value;
            const resultsContentLocal = tabSection.querySelector('.formDownloadResults');

            inputProduct.addEventListener('change', () => {
                // console.log('Produto', inputProduct.value);
                if (+inputProduct.value === 0) {
                    // console.log('Produto Vazio', inputProduct.value);
                    inputProduct.parentElement.classList.add('errorField');
                } else if (+inputUnit.value === 0) {
                    // console.log('Unidade Vazio', inputUnit.value);
                    inputProduct.parentElement.classList.remove('errorField');
                    inputUnit.parentElement.classList.add('errorField');
                } else {
                    inputUnit.parentElement.classList.remove('errorField');
                    this.getFiles(inputProduct, inputUnit, resultsContentLocal, template);
                }
            });
            
            inputUnit.addEventListener('change', () => {
                // console.log('Produto', inputProduct.value);
                if (+inputProduct.value === 0) {
                    // console.log('Produto Vazio', inputProduct.value);
                    inputProduct.parentElement.classList.add('errorField');
                } else if (+inputUnit.value === 0) {
                    // console.log('Unidade Vazio', inputUnit.value);
                    inputProduct.parentElement.classList.remove('errorField');
                    inputUnit.parentElement.classList.add('errorField');
                } else {
                    inputUnit.parentElement.classList.remove('errorField');
                    this.getFiles(inputProduct, inputUnit, resultsContentLocal, template);
                }
            });

        });
    }

    getFiles($unit, $product, $section, $template) {
        axios
            .post('/getOrientations', {
                unit: +$unit.value,
                product: +$product.value,
            })
            .then((response) => {
                // console.log(response.data.orientations);
                if (response.data.orientations.length > 0) {

                    $section.querySelector('.noContent').classList.add('hidden')

                    $section.querySelector('#labelProduct').innerHTML = $product.options[$product.selectedIndex].text;
                    $section.querySelector('#labelUnit').innerHTML = $unit.options[$unit.selectedIndex].text;

                    $section.classList.add('active');
                    // console.log($template)
                    let localContent = ''
                    if($template == 'sidebar') {
                        localContent = $section.querySelector('.listDownloads');
                    } else {
                        localContent = $section.querySelector('.listDownloads tbody');
                    }
                    localContent.innerHTML = '';

                    const contentResult = response.data.orientations;
                    contentResult.forEach((content) => {
                        // console.log(content);
                        if($template == 'sidebar') {
                            localContent.insertAdjacentHTML(
                                'beforeend',
                                this.templateContent(content.title, content.file_pt, content.file_en, content.file_es)
                            );
                        } else {

                            const base = Math.log(content.filesize) / Math.log(1024);
                            const suffixes = ['B', 'KB', 'MB', 'GB', 'TB'];
                            const fileSize =  (Math.round(Math.pow(1024, base - Math.floor(base)) * 100) / 100).toFixed(2) + ' ' + suffixes[Math.floor(base)];

                            localContent.insertAdjacentHTML(
                                'beforeend',
                                this.templateContentFull(content.title, content.description, fileSize, content.file_pt, content.file_en, content.file_es)
                            );

                        }
                    });
                } else {
                    $section.classList.add('active');
                    $section.querySelector('#labelProduct').innerHTML = $product.options[$product.selectedIndex].text;
                    $section.querySelector('#labelUnit').innerHTML = $unit.options[$unit.selectedIndex].text;
                    const localContent = $section.querySelector('.listDownloads');
                    localContent.innerHTML = '';
                    $section.querySelector('.noContent').classList.remove('hidden')
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    templateContent(name, linkPT, linkEN, linkES) {
        let template = `
        <div class="itemDownload bg-white dark:bg-black dark:border dark:border-white p-8 rounded">
            <div class="font-semibold text-2xl leading-10 mb-4 dark:text-white">${name}</div>
            <div class="flex flex-row flex-wrap gap-4">`;
        if (linkPT) {
            template += `<a href="${linkPT}" download target="_blank" class="flex flex-row items-center text-xs text-unigreen700 dark:text-white"><span class="text-unigreen700 dark:text-dark"><svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.966797" width="32" height="32" rx="4" fill="currentColor"/><path d="M9.59961 20.566V22.166C9.59961 22.5904 9.76818 22.9973 10.0682 23.2974C10.3683 23.5974 10.7753 23.766 11.1996 23.766H20.7996C21.224 23.766 21.6309 23.5974 21.931 23.2974C22.231 22.9973 22.3996 22.5904 22.3996 22.166V20.566M11.9996 15.766L15.9996 19.766M15.9996 19.766L19.9996 15.766M15.9996 19.766V10.166" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span> <span class="ml-2">Português</span></a>`;
        }
        if (linkEN) {
            template += `<a href="${linkEN}" download target="_blank" class="flex flex-row items-center text-xs text-unigreen700 dark:text-white"><span class="text-unigreen700 dark:text-dark"><svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.966797" width="32" height="32" rx="4" fill="currentColor"/><path d="M9.59961 20.566V22.166C9.59961 22.5904 9.76818 22.9973 10.0682 23.2974C10.3683 23.5974 10.7753 23.766 11.1996 23.766H20.7996C21.224 23.766 21.6309 23.5974 21.931 23.2974C22.231 22.9973 22.3996 22.5904 22.3996 22.166V20.566M11.9996 15.766L15.9996 19.766M15.9996 19.766L19.9996 15.766M15.9996 19.766V10.166" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span> <span class="ml-2">Espanhol</span></a>`;
        }
        if (linkES) {
            template += `<a href="${linkES}" download target="_blank" class="flex flex-row items-center text-xs text-unigreen700 dark:text-white"><span class="text-unigreen700 dark:text-dark"><svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.966797" width="32" height="32" rx="4" fill="currentColor"/><path d="M9.59961 20.566V22.166C9.59961 22.5904 9.76818 22.9973 10.0682 23.2974C10.3683 23.5974 10.7753 23.766 11.1996 23.766H20.7996C21.224 23.766 21.6309 23.5974 21.931 23.2974C22.231 22.9973 22.3996 22.5904 22.3996 22.166V20.566M11.9996 15.766L15.9996 19.766M15.9996 19.766L19.9996 15.766M15.9996 19.766V10.166" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span> <span class="ml-2">Espanhol</span></a>`;
        }
        template += `
            </div>
        </div>
        `;
        return template;
    }
    
    templateContentFull(name, decription, fileSize, linkPT, linkEN, linkES) {
        let template = `

            <tr class="border-b border-unigreen bg-white dark:bg-black dark:text-white dark:border-white">
                <td class="px-6 py-4">
                    ${name}
                </td>
                <td class="w-[28.125rem] whitespace-nowrap px-6 py-4">
                    ${decription}
                </td>
                <td class="px-6 py-4">
                    ${fileSize}
                </td>
                <td class="px-6 py-4">
                    <div class="flex flex-row flex-nowrap gap-3">`;
                    if (linkPT) {
                        template += `<a href="${linkPT}"  target="_blank" download
                        class="flex flex-row items-center text-xs text-unigreen700 dark:text-white"><span class="text-unigreen700 dark:text-dark"><svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.966797" width="32" height="32" rx="4" fill="currentColor"/><path d="M9.59961 20.566V22.166C9.59961 22.5904 9.76818 22.9973 10.0682 23.2974C10.3683 23.5974 10.7753 23.766 11.1996 23.766H20.7996C21.224 23.766 21.6309 23.5974 21.931 23.2974C22.231 22.9973 22.3996 22.5904 22.3996 22.166V20.566M11.9996 15.766L15.9996 19.766M15.9996 19.766L19.9996 15.766M15.9996 19.766V10.166" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span> <span
                            class="ml-2">PT</span></a>`;
                    }
                    if (linkEN) {
                        template += `<a href="${linkEN}"  target="_blank" download
                        class="flex flex-row items-center text-xs text-unigreen700 dark:text-white"><span class="text-unigreen700 dark:text-dark"><svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.966797" width="32" height="32" rx="4" fill="currentColor"/><path d="M9.59961 20.566V22.166C9.59961 22.5904 9.76818 22.9973 10.0682 23.2974C10.3683 23.5974 10.7753 23.766 11.1996 23.766H20.7996C21.224 23.766 21.6309 23.5974 21.931 23.2974C22.231 22.9973 22.3996 22.5904 22.3996 22.166V20.566M11.9996 15.766L15.9996 19.766M15.9996 19.766L19.9996 15.766M15.9996 19.766V10.166" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span> <span
                            class="ml-2">EN</span></a>`;
                    }
                    if (linkES) {
                        template += `<a href="${linkES}"  target="_blank" download
                        class="flex flex-row items-center text-xs text-unigreen700 dark:text-white"><span class="text-unigreen700 dark:text-dark"><svg width="32" height="33" viewBox="0 0 32 33" fill="none" xmlns="http://www.w3.org/2000/svg"><rect y="0.966797" width="32" height="32" rx="4" fill="currentColor"/><path d="M9.59961 20.566V22.166C9.59961 22.5904 9.76818 22.9973 10.0682 23.2974C10.3683 23.5974 10.7753 23.766 11.1996 23.766H20.7996C21.224 23.766 21.6309 23.5974 21.931 23.2974C22.231 22.9973 22.3996 22.5904 22.3996 22.166V20.566M11.9996 15.766L15.9996 19.766M15.9996 19.766L19.9996 15.766M15.9996 19.766V10.166" stroke="white" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span> <span
                            class="ml-2">ES</span></a>`;
                    }
                template += `</div>
                </td>
            </tr>`;
        return template;
    }

}

if (document.querySelector('.uni-tabs')) {
    new Tabs();
}
